export default __webpack_public_path__ + "static/media/tutorialMomo-3.12.9904c72f.png";